import React from "react";
import { useSortBy, UseSortByProps } from "react-instantsearch";
import { translate } from "../../../Services/translation";

function CustomSortBy(props: UseSortByProps) {
  const { currentRefinement, options, refine } = useSortBy(props);

  return (
    <div className="algolia-product-sorting">
      <label className="algolia-product-sorting__label">
        {translate("algolia.sort-by.title")}:&nbsp;
        <select
          className="algolia-product-sorting__select"
          onChange={(event) => refine(event.target.value)}
          value={currentRefinement}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}

export default CustomSortBy;
